import { i18n } from 'boot/i18n'
import { config } from 'src/boot/tenantConfig'
import { date as dateLib } from 'quasar'

export default {
  defaultInvoiceUnit (type) {
    switch (type) {
      case 'NATURAL_GAS':
      case 'ELECTRICITY':
      case 'ELECTRIC_HEATING':
        return 'KWH'
      default:
        return null
    }
  },
  defaultMeterUnit (type) {
    switch (type) {
      case 'NATURAL_GAS':
        return 'CBM'
      case 'ELECTRICITY':
      case 'ELECTRIC_HEATING':
        return 'KWH'
      default:
        return null
    }
  },
  formatAllDates (obj, format = 'YYYY-MM-DD') {
    Object.entries(obj)
      .forEach(([key, value]) => {
        if (value instanceof Date) {
          obj[key] = dateLib.formatDate(value, format)
        }
      })
  },
  formatDateIn (obj, dateProp, format = 'YYYY-MM-DD') {
    const date = obj?.[dateProp]
    if (!date) {
      return null
    }
    obj[dateProp] = dateLib.formatDate(date, format)
    return obj[dateProp]
  },
  formatPriceUnitValue (puv, valueProperty = 'gross') {
    if (!puv) {
      return ''
    }

    const { [valueProperty]: v, currency: c, unit: u, decimals: d } = puv

    return this.formatCurrency({ v, c, u, d })
  },
  formatCurrency (value, perUnitSign = '/', prependCurrency = false) {
    const v = value.v
    let c = value.c
    let u = value.u
    const d = value.d ?? 2

    let formatted = new Intl.NumberFormat(i18n.locale, {
      minimumFractionDigits: d,
      maximumFractionDigits: d
    }).format(v)

    if (u && i18n.te('units.' + u.toLowerCase())) {
      u = i18n.t('units.' + u.toLowerCase())
    }

    if (c && i18n.te('units.' + c.toLowerCase())) {
      c = i18n.t('units.' + c.toLowerCase())
    }

    formatted = prependCurrency ? c + formatted : `${formatted} ${c}`

    if (u) {
      formatted += ` ${perUnitSign} ${u}`
    }

    return formatted
  },

  typeIcon (value) {
    switch (value) {
      case 'ELECTRICITY':
        return 'app:energy-electricity'
      case 'WATER':
        return 'app:energy-water'
      case 'NATURAL_GAS':
        return 'app:energy-natural-gas'
      case 'DISTRICT_HEATING':
      case 'ELECTRIC_HEATING':
        return 'app:energy-district-heating'
      case 'INTERNET':
        return 'app:energy-internet'
      case 'CITIZEN_CARD':
        return 'local_activity'
      case 'E_MOBILITY':
        return 'app:energy-e-mobility'
      case 'WASTE_WATER':
        return 'app:energy-waste-water'
      default:
        return 'stop_circle'
    }
  },
  typeBackgroundColor (value) {
    const color = config.get('colors.energyTypes.background.' + value.toLowerCase())
    if (color) {
      return color
    }
    switch (value) {
      case 'ELECTRICITY':
        return '#C21035'
      case 'WATER':
        return '#0294CF'
      case 'NATURAL_GAS':
        return '#F7DD01'
      case 'DISTRICT_HEATING':
        return '#93001e'
      case 'INTERNET':
      case 'CITIZEN_CARD':
        return '#006AC5'
      case 'E_MOBILITY':
        return '#02CB37'
      case 'WASTE_WATER':
        return '#6e6e6e'
      default:
        return '#2a2a2a'
    }
  },
  typeTextColor (value) {
    const color = config.get('colors.energyTypes.foreground.' + value.toLowerCase())
    if (color) {
      return color
    }
    switch (value) {
      case 'ELECTRICITY':
      case 'WATER':
      case 'NATURAL_GAS':
      case 'DISTRICT_HEATING':
      case 'INTERNET':
      case 'CITIZEN_CARD':
      case 'E_MOBILITY':
      case 'WASTE_WATER':
      default:
        return '#fff'
    }
  },
  formatAddress (getMasterDataDescription, value, inline = false, includeAddress = true, includeName = true) {
    if (!value) {
      return ''
    }

    let { title, firstName, lastName, businessName, businessContactPartner, nameAddition, addressAddition, street, houseNumber, zipCode, city, country, poBox } = value
    if (country === 'DE') {
      country = null
    } else {
      country = getMasterDataDescription('countries', country)
    }
    const lines = []
    const result = []

    if (includeName) {
      // salutation = getMasterDataDescription('salutations', salutation)
      title = getMasterDataDescription('titles', title)
      lines.push([title, firstName, lastName, businessName, nameAddition]) // salutation
      lines.push([businessContactPartner])
    }
    if (includeAddress) {
      lines.push([addressAddition])
      lines.push([street, houseNumber])
      lines.push([poBox])
      lines.push([zipCode, city])
      lines.push([country])
    }

    lines.forEach(l => {
      const line = l.filter(p => p)
      if (line.length > 0) {
        result.push(line.join(' '))
      }
    })

    if (inline) {
      return result.join(', ')
    } else {
      return result.join('<br>')
    }
  }
}
